import React, { Component } from "react";
import { connect } from "react-redux";

import { useDropzone } from "react-dropzone";
import { Button } from "reactstrap";
import axios from "axios";
import Select from "react-select";
import moment from "moment";
import { msgActions, loaderMaskActions, configActions } from "../../../redux/actions";

function AcceptExcel(props) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({
    accept: ".xlsx",
    onDrop: props.onDrop,
    multiple: false,
  });

  return (
    <div id="dropZone" className="container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        {isDragAccept && <p>All files will be accepted</p>}
        {isDragReject && <p>Some files will be rejected</p>}
        {!isDragActive && (
          <>
            <p>Drag 'n' drop some files here, or click to select files</p>
            <em>(Only *.xlsx file will be accepted)</em>
          </>
        )}
        <ul className="list-group mt-2">
          {acceptedFiles.length > 0 &&
            acceptedFiles.map((acceptedFile, index) => (
              <li
                key={index}
                className="list-group-item list-group-item-success"
              >
                {acceptedFile.name}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

class UploadDeliveryDelaysExcel extends Component {
  state = {
    selectedFile: null,
    yearOptions: [],
  };

  componentDidMount() {
    var dt = new Date();
    var _currentYear = dt.getFullYear();
    if (dt.getMonth() === 0 && dt.getDate() < 16) {
      var yearOptions = [
        {
          value: (_currentYear - 1).toString(),
          label: (_currentYear - 1).toString(),
        },
        { value: _currentYear.toString(), label: _currentYear.toString() },
      ];
      this.setState({ yearOptions });
    } else {
      this.props.dispatch(
        configActions.setExcelUploadYear(_currentYear.toString())
      );
    }
    this.props.dispatch(configActions.getLastUploadList());
  }

  onFilesDrop = (files) => {
    var _file = files[files.length - 1];
    this.setState({ selectedFile: _file });
  };
  handleUploadFile = async (event) => {
    const { selectedFile } = this.state;
    const { dispatch, Year } = this.props;
    dispatch(loaderMaskActions.show("Uploading Excel File..."));
    let params = {
      FileName: selectedFile.name,
      Year,
    };
    try {
      let response = await axios.post(
        "configuration/ldls/uploadExcelFile",
        selectedFile,
        {
          headers: { "Content-Type": "application/octet-stream" },
          params,
        }
      );
      var json = response.data;
      if (json.Errors && json.Errors.length > 0) {
        dispatch(msgActions.error("Uploading Excel File", json.Errors[0]));
        return;
      }
      // Show success message
      dispatch(
        msgActions.success(
          "Uploading Excel File",
          "Excel File uploaded successfully."
        )
      );
    } catch (error) {
      dispatch(msgActions.error("Uploading Excel File", error.message));
    } finally {
      dispatch(loaderMaskActions.hide(""));
    }
  };

  generateUploadsGrid = (uploads) => {
    return (
      <table className="table" style={{ display: "table" }}>
        <thead>
          <tr>
            <th>User name</th>
            <th>File name</th>
            <th>Created at</th>
          </tr>
        </thead>
        <tbody>
          {(uploads || []).map((item, index) => (
            <tr key={item._id}>
              <td>{item.userName}</td>
              <td>{item.fileName}</td>
              <td>
                {item.created
                  ? moment
                      .utc(item.created, moment.ISO_8601)
                      .format("DD-MM-YYYY HH:mm:ss")
                  : "n/a"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { lastUploads } = this.props;
    return (
      <div className="settings-main row">
        <div
          className="setting-container"
          style={{ padding: "1em", marginTop: "3em" }}
        >
          <div className="row">
            <div className="col-sm-12 platform-container">
              {this.state.yearOptions && this.state.yearOptions.length > 0 && (
                <div style={{ display: "flex", padding: "0.5em 1em" }}>
                  <div style={{ padding: "0.3em 1em 0.3em 0" }}>Year</div>
                  <div style={{ flex: 1 }}>
                    <Select
                      name="year"
                      clearable={false}
                      value={this.props.Year}
                      onChange={(selectedYear) =>
                        this.props.dispatch(
                          configActions.setExcelUploadYear(selectedYear.value)
                        )
                      }
                      options={this.state.yearOptions}
                    />
                  </div>
                </div>
              )}
              <AcceptExcel onDrop={this.onFilesDrop} />
              <Button
                disabled={!this.state.selectedFile || !this.props.Year}
                color="primary"
                className="EventSearchSubmit"
                style={{ marginLeft: "20px" }}
                onClick={this.handleUploadFile}
              >
                Upload
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 platform-container">
              <div style={{ margin: "0 10px 10px" }}>
                <strong>Last uploads</strong>
              </div>
              {lastUploads &&
                lastUploads.length > 0 &&
                this.generateUploadsGrid(lastUploads)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    Year: state.config.excelUploadYear,
    lastUploads: state.config.lastUploads,
    loaderMask: state.loaderMask,
  };
}

export default connect(mapStateToProps)(UploadDeliveryDelaysExcel);
